import React, { useState, Fragment } from 'react';

import Filter from '../../components/Filter/Filter';

import DataTable from '../../components/Table/DataTable';
import QueueItemHistoryModal from './QueueItemHistoryModal';

import { useGlobalContext } from '../../services/globalContext';
import { useDebounce } from '../../services/debounce';
import queueService from '../../services/queueService';
import utility from '../../services/utility';
import { useDynamicQuery, useQueryParams } from '../../services/dynamicQuery';
import { Col, Row, Card, CardHeader, Badge } from 'reactstrap';

import { OPERATION_TYPE } from '../../enums/operationType';
import { QUEUE_STATUS } from '../../enums/queueStatus';

const getDataHandler = async (show, search, page, pageSize) => {
    var data = await queueService.queueItems(show, search, page, pageSize)
        .then(response => response);
    return data;
}

const formatStatus = (status) => {
    const { background, name } = QUEUE_STATUS[status];
    return <Badge color={background}>{name}</Badge>;
}

const FileProcessingQueue = () => {
    const globalContext = useGlobalContext();
    const params = useQueryParams();
    const [search, setSearch] = useState(params.search || "");
    const [show, setShow] = useState(params.show || globalContext.show || "");
    const [modal, setModal] = useState(false);
    const [historicalData, setHistoricalData] = useState({});

    useDynamicQuery({ show, search });

    const showChangeHandler = (nextShow) => {
        setShow(nextShow);
        globalContext.show = nextShow;
    }

    const searchChangeHandler = (nextSearch) => {
        searchChangeDebouncer(nextSearch);
    }

    const searchChangeDebouncer = useDebounce(setSearch, 500, false, []);

    const toggleModal = () => setModal(!modal);

    const showItemHistory = item => {
        queueService.history(item.mediaId, item.show)
            .then(data => {
                setHistoricalData({
                    show: item.show,
                    mediaId: item.mediaId,
                    data: data
                })
                toggleModal();
            });
    }

    const columns = ["mediaId", "show", "creationDate", "operation", "status", "startDate", "finishDate", "details"];
    const options = {
        key: "id",
        pagination: { enabled: true, serverSide: true },
        column: {
            "mediaId": {
                header: "Media",
                searchable: true,
                classes: ["text-center"]
            },
            "operation": {
                header: "Operation",
                transform: (value) => utility.mapValue(value, OPERATION_TYPE),
                width: "10rem"
            },
            "status": {
                header: "Status",
                transform: (value) => formatStatus(value)
            },
            "show": {
                header: "Show",
                filter: (value) => show.length > 0 ? show.toLowerCase().includes(value.toLowerCase()) : true
            },
            "creationDate": {
                header: "Creation Date",
                transform: utility.formatDateTimeString,
                width: "10rem"
            },
            "finishDate": {
                header: "Finish Date",
                transform: utility.formatDateTimeString,
                width: "10rem"
            },
            "startDate": {
                header: "Start Date",
                transform: utility.formatDateTimeString,
                width: "10rem"
            },
            "details": {
                header: "Details",
                classes: ["pre-wrap"],
                transform: utility.formatMultilineString,
                searchable: true
            }
        },
        row: {
            click: (item) => showItemHistory(item)
        }
    };

    return (
        <Fragment>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <Filter
                                show={show}
                                search={params.search}
                                onShowChanged={showChangeHandler}
                                onSearchChanged={searchChangeHandler}
                                hideFileType={true}
                            />
                        </CardHeader>
                        <DataTable
                            columns={columns}
                            options={options}
                            filters={show}
                            search={search}
                            onGetData={getDataHandler}
                            classes={["table-sm", "align-items-center", "table-flush", "table", "table-clickable"]} />
                    </Card>
                </Col>
            </Row>
            <QueueItemHistoryModal isOpen={modal} toggle={toggleModal} media={historicalData} />
        </Fragment>
    );
}

export default FileProcessingQueue;